export const INSERT_IN_CART = 'INSERT_IN_CART';
export const EDIT_ITEM_IN_CARRELLO = 'EDIT_ITEM_IN_CARRELLO';
export const RIMUOVI_ITEM_DA_CARRELLO = 'RIMUOVI_ITEM_DA_CARRELLO';
export const REMOVE_ALL_ITEM_IN_CART = 'REMOVE_ALL_ITEM_IN_CART';
